import React, { useEffect } from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { IoHomeOutline } from "react-icons/io5";
import { GiSettingsKnobs } from "react-icons/gi";

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { TbLogout2 } from "react-icons/tb";

import { logoutSuccess } from '../state/authRedux';
import { useNavigate } from 'react-router-dom';
import { IoMenuOutline } from "react-icons/io5";

import { FaBlogger } from "react-icons/fa6";
import { TfiWrite } from "react-icons/tfi";
import { FaUsers } from "react-icons/fa";
import { IoLibraryOutline } from "react-icons/io5";
import { MdOutlineLiveTv } from "react-icons/md";

function Navbar({open,setOpen,highlight}) {
    //const [open,setOpen] = useState(true);
    const [menu,setMenu] = useState(0);
    const highlightIndex = useSelector((state)=>state.highlight.index)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const logOut = () => {
        dispatch(logoutSuccess())
        navigate('/login')
        console.log('logout now')
    }

    const LinkOnClick = (index) => {
        console.log('link clicked')
    }

    const Menus = [
        {title:"Home",path:'/adminhome',icon:<IoHomeOutline />,spacing:false},
        {title:"Write Blog",path:'/createblog',icon:<TfiWrite  />,spacing:false},
        {title:"Manage Blogs",path:'/manageBlogs',icon:<FaBlogger  />,spacing:false},
        {title:"Write Term",path:'/createTerm',icon:<TfiWrite  />,spacing:false},
        {title:"Manage Terms",path:'/ManageTerms',icon:<IoLibraryOutline /> ,spacing:false},
        {title:"Manage Users",path:'/manageUsers',icon:<FaUsers />,spacing:false},
        {title:"Create Webinar",path:'/createwebinar',icon:<MdOutlineLiveTv  />,spacing:false},
        {title:"Create Job",path:'/createvacancy',icon:<TfiWrite  />,spacing:false},
        {title:"Manage Jobs",path:'/manageVacancies',icon:<TfiWrite  />,spacing:false},
        {title:"Create Paper",path:'/CreatePublication',icon:<TfiWrite  />,spacing:false},
        {title:"Manage Papers",path:'/managewhitepapers',icon:<TfiWrite  />,spacing:false},
        {title:"Manage Webinars",path:'/managewebinars',icon:<MdOutlineLiveTv  />,spacing:false},
        {title:"Create Project",path:'/createproject',icon:<TfiWrite  />,spacing:false},
        {title:"Manage Projects",path:'/manageprojects',icon:<TfiWrite  />,spacing:false},
    ]

    useEffect(()=>{
    })

  return (
        <div className={`font-sans text-[14px] font-normal leading-[20px] text-gray-400 z-50 md:relative  h-screen  md:z-0 ${open?"w-[80%]":"w-[10%]"} border-r border-gray-500  
        bg-[#030527] md:h-screen md:p-5 md:pt-8 ${open?"md:w-[15%]":"md:w-[5%]"} duration-300 ease-in-out relative`}>
            {<IoMenuOutline className={`
            ml-1 text-white text-2xl  
            absolute-right-1 top-9 cursor-pointer border border-precision ${!open && "rotate-180"} 
            `} onClick={()=>setOpen(!open)}/>}
            {/*
            <div className='duration-300 ease-in-out h-[5%] '>
                <h3 style={{ textOverflow: "" }} className={`${!open && "opacity-0 hidden"} font-sans text-[14px] font-normal
                                                leading-[20px] whitespace-nowrap overflow-hidden font-roboto duration-300 ease-in-out text-white  text-lg`}>3D AI Gen</h3>
            </div>*/}
            {/*
            <div className={`flex items-center rounded-md mt-6 ${!open?"px-2.5":"px-4"} py-2 bg-slate-500`}>
                <BsSearch className={`text-white cursor-pointer ${open && "mr-2"} text-lg block float-left mr-2`}/>
                <input type='search' placeholder='Search' className={`text-base bg-transparent w-full text-white focus:outline-none ${!open && "hidden"}`}></input>
            </div>*/}
            <div className='pt-2 duration-300 ease-in-out h-[85%]'>
                {Menus.map((menu,index)=>
                    <Link onClick={(e)=>LinkOnClick(index)}to={menu.path} key={index} className={`h-[40px] ${index === highlightIndex?`bg-slate-500`:null} text-gray-300 cursor-pointer gap-x-4 text-sm flex p-2 items-center hover:bg-slate-500 rounded-md duration-300 ease-in-out ${menu.spacing?"mb-9":"mb-2"}`}>
                        <span className='text-md block float-left duration-300 ease-in-out'>
                            {menu.icon}
                        </span>
                        <span style={{ textOverflow: "" }} className={`whitespace-nowrap overflow-hidden text-base font-medium flex-1 duration-300 ease-in-out ${!open && "hidden"}`}>{menu.title}</span>
                    </Link>
                 
                )}
                <button onClick={()=>{console.log('settings')}} className={`h-[40px] text-gray-300 cursor-pointer gap-x-4 text-sm flex p-2 items-center duration-300 ease-in-out hover:bg-slate-500 rounded-md w-[100%]`}>
                    <span className={`text-md block float-left`}><GiSettingsKnobs/></span>
                    <span style={{ textOverflow: "" }} className={` whitespace-nowrap overflow-hidden text-base font-medium ${!open && "hidden"}`}>Settings</span>
                </button>
                <button onClick={()=>logOut()} className={` h-[40px] text-gray-300 cursor-pointer gap-x-4 text-sm flex duration-300 ease-in-out p-2 items-center hover:bg-slate-500 rounded-md w-[100%]`}>
                    <span  className={`text-md block float-left`}><TbLogout2/></span>
                    <span style={{ textOverflow: "" }} className={`whitespace-nowrap overflow-hidden text-base font-medium ${!open && "hidden"}`}>Log Out</span>
                </button>
            </div>
        </div>
    
    
  )
}

export default Navbar;